import { useTranslation } from 'react-i18next'
import { getDateFromDate } from '@/utils'

export const ListDate = ({ date }: { date: Date }) => {
  const { i18n } = useTranslation()

  return <>{getDateFromDate(date, i18n.language)}</>
}
